import { Button, DialogTitle, Typography } from '@mui/material';

import { clipboardWrite } from '/helpers';
import { snackbarService } from '/common/snackbarService';

import { CodesNodeContent } from './styles';

interface IRecoveryCodesProps {
  codes: string[];
}

export const RecoveryCodes = (props: IRecoveryCodesProps) => {
  const { codes } = props;

  const handleCopy = () => {
    clipboardWrite(codes.join(' '));
    snackbarService.success('Copied');
  };

  return (
    <>
      <DialogTitle sx={{ p: 0 }}>Recovery codes</DialogTitle>
      <Typography>Copy and save these codes in case you lose MFA device.</Typography>
      <CodesNodeContent gap={2}>
        {codes.map((c) => (
          <Typography key={c}>{c}</Typography>
        ))}
        <Button size='large' sx={{ gridColumn: '1 / -1' }} onClick={handleCopy}>
          Copy
        </Button>
      </CodesNodeContent>
    </>
  );
};
